import type { ListAttractionsParams, RankScopeType } from '~/types/attractionTypes';

export function detectActiveScope(
  filters: ListAttractionsParams,
): { scopeType: RankScopeType; scopeValue: string } | null {
  if (filters.city) return { scopeType: 'city', scopeValue: filters.city };
  if (filters.province) return { scopeType: 'province', scopeValue: filters.province };
  if (filters.state) return { scopeType: 'state', scopeValue: filters.state };
  if (filters.countryCode) return { scopeType: 'country', scopeValue: filters.countryCode };
  if (filters.country) return { scopeType: 'country', scopeValue: filters.country };
  return null;
}
